export const occupationOptions = [
  {
    label: "Administration",
    value: "administration",
  },
  {
    label: "Office worker",
    value: "office-worker",
  },
  {
    label: "Professional",
    value: "professional",
  },
  {
    label: "Sales",
    value: "sales",
  },
  {
    label: "Trade",
    value: "trade",
  },
  {
    label: "Unskilled",
    value: "unskilled",
  },
  {
    label: "Home duties",
    value: "home-duties",
  },
  {
    label: "Other",
    value: "other",
  },
];

export const employmentIndustryOptions = [
  {
    value: "arts",
    label: "Arts & Entertainment",
  },
  {
    value: "construction-manufacturing",
    label: "Building / Construction / Manufacturing",
  },
  {
    value: "non-profit-religious",
    label: "Charity / Non-Profit / Religious Org",
  },
  {
    value: "childcare",
    label: "Childcare",
  },
  {
    value: "education",
    label: "Education / University",
  },
  {
    value: "events",
    label: "Events planning / Catering",
  },
  {
    value: "agriculture-fishing-forestry",
    label: "Farming / Agriculture / Fishing / Forestry",
  },
  {
    value: "finance-insurance",
    label: "Financial / Insurance services",
  },
  {
    value: "government",
    label: "Government",
  },
  {
    value: "health-services",
    label: "Health services / Hopitals / Doctors / Nurses / Physio / Chiro",
  },
  {
    value: "hospitality",
    label: "Hospitality / Bars / Pubs / Clubs / Hotels",
  },
  {
    value: "technology",
    label: "Information Technology",
  },
  {
    value: "mining-energy",
    label: "Mining / Oil / Gas / Energy",
  },
  {
    value: "professional-services",
    label: "Professional services",
  },
  {
    value: "real-estate",
    label: "Real estate",
  },
  {
    value: "retail",
    label: "Retail (clothing, footwear, homeware, accessories)",
  },
  {
    value: "services",
    label: "Services / Cleaners / Barbers / Mechanics",
  },
  {
    value: "sport",
    label: "Sports & Recreation",
  },
  {
    value: "supermarkets-fast-food-petrol",
    label: "Supermarkets / Fast Food / Take-away / Petrol stations",
  },
  {
    value: "tourism",
    label: "Tourism / Travel agent / Airlines / Hotels / Motels",
  },
  {
    value: "transport-logistics",
    label: "Transport / Logistics",
  },
  {
    value: "vet",
    label: "Vet",
  },
  {
    value: "home-duties",
    label: "Home duties",
  },
  {
    value: "other",
    label: "Other",
  },
];

export const employmentStatusOptions = [
  {
    value: "full-time",
    label: "Full time",
  },
  {
    value: "part-time",
    label: "Part time",
  },
  {
    value: "casual",
    label: "Casual",
  },
  {
    value: "contract",
    label: "Contract",
  },
  {
    value: "self-employed",
    label: "Self-employed",
  },
];
